export default __webpack_public_path__ + "static/media/andreas-klinger.80dea23f.jpeg";